function applyColors(parent) {
  parent.querySelectorAll('.product-card [data-color-image]').forEach(el => {
    // console.log({ el });
    const url = el.getAttribute('data-color-image');
  
    const colorThief = new ColorThief();
    const img = new Image();
  
    img.addEventListener('load', function() {
      const color = `rgb( ${ colorThief.getColor(img).join(',') } )`
      $(el).closest('.product-card').css('--image-color', color);
  
  
    });
  
    img.crossOrigin = 'Anonymous';
    img.src = url;
  
  })
}
applyColors(document);

$(function() {
  const collectionTl = global_gsap.timeline();

  collectionTl
  .fromTo('.collection-product-grid__products', {
    autoAlpha: 0,
    delay: 1,
  }, { 
    autoAlpha: 1,
  })
  .from('.collection-product-grid__products .product-card__image .image', { 
    autoAlpha: 0, 
    duration: 1.8, 
    ease: 'expo.out', 
    stagger: .08 
  })

  document.body.classList.remove('hide-products-grid');
})